"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastProgramApi = exports.BroadcastProgramApiFactory = exports.BroadcastProgramApiFp = exports.BroadcastProgramApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * BroadcastProgramApi - axios parameter creator
 * @export
 */
const BroadcastProgramApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: ListBroadcastPrograms - Difficulty: 3 - Roles can execute: ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Yayın takvimini listeler. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.BroadcastCover gönderebilirsiniz. PersonalTrainer fotoğrafı için ise PhotoType.SmallUserAvatar gönderebilirsiniz.
         * @param {string} [date]
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastPrograms: (date, isLive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program/list_broadcast_programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substr(0, 10) :
                    date;
            }
            if (isLive !== undefined) {
                localVarQueryParameter['isLive'] = isLive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: RateBroadcast - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir müşterinin, katılmış olduğu bir canlı yayın bittikten sonra, yayını puanlamasını sağlar.
         * @param {RateBroadcastCommand} [rateBroadcastCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateBroadcast: (rateBroadcastCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program/rate_broadcast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateBroadcastCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: SetBurntCalories - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün, kendi yaptığı canlı yayın bittikten sonra canlı yayında yakılan kaloriyi girmesini sağlar.
         * @param {SetBurntCaloriesCommand} [setBurntCaloriesCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBurntCalories: (setBurntCaloriesCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/broadcast_program/set_burnt_calories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setBurntCaloriesCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BroadcastProgramApiAxiosParamCreator = BroadcastProgramApiAxiosParamCreator;
/**
 * BroadcastProgramApi - functional programming interface
 * @export
 */
const BroadcastProgramApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BroadcastProgramApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: ListBroadcastPrograms - Difficulty: 3 - Roles can execute: ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Yayın takvimini listeler. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.BroadcastCover gönderebilirsiniz. PersonalTrainer fotoğrafı için ise PhotoType.SmallUserAvatar gönderebilirsiniz.
         * @param {string} [date]
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastPrograms(date, isLive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBroadcastPrograms(date, isLive, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: RateBroadcast - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir müşterinin, katılmış olduğu bir canlı yayın bittikten sonra, yayını puanlamasını sağlar.
         * @param {RateBroadcastCommand} [rateBroadcastCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateBroadcast(rateBroadcastCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rateBroadcast(rateBroadcastCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: SetBurntCalories - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün, kendi yaptığı canlı yayın bittikten sonra canlı yayında yakılan kaloriyi girmesini sağlar.
         * @param {SetBurntCaloriesCommand} [setBurntCaloriesCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBurntCalories(setBurntCaloriesCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setBurntCalories(setBurntCaloriesCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.BroadcastProgramApiFp = BroadcastProgramApiFp;
/**
 * BroadcastProgramApi - factory interface
 * @export
 */
const BroadcastProgramApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BroadcastProgramApiFp)(configuration);
    return {
        /**
         * Operation Id: ListBroadcastPrograms - Difficulty: 3 - Roles can execute: ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Yayın takvimini listeler. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.BroadcastCover gönderebilirsiniz. PersonalTrainer fotoğrafı için ise PhotoType.SmallUserAvatar gönderebilirsiniz.
         * @param {string} [date]
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBroadcastPrograms(date, isLive, options) {
            return localVarFp.listBroadcastPrograms(date, isLive, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: RateBroadcast - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER
         * @summary Bir müşterinin, katılmış olduğu bir canlı yayın bittikten sonra, yayını puanlamasını sağlar.
         * @param {RateBroadcastCommand} [rateBroadcastCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateBroadcast(rateBroadcastCommand, options) {
            return localVarFp.rateBroadcast(rateBroadcastCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: SetBurntCalories - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
         * @summary Kişisel antrenörün, kendi yaptığı canlı yayın bittikten sonra canlı yayında yakılan kaloriyi girmesini sağlar.
         * @param {SetBurntCaloriesCommand} [setBurntCaloriesCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBurntCalories(setBurntCaloriesCommand, options) {
            return localVarFp.setBurntCalories(setBurntCaloriesCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BroadcastProgramApiFactory = BroadcastProgramApiFactory;
/**
 * BroadcastProgramApi - object-oriented interface
 * @export
 * @class BroadcastProgramApi
 * @extends {BaseAPI}
 */
class BroadcastProgramApi extends base_1.BaseAPI {
    /**
     * Operation Id: ListBroadcastPrograms - Difficulty: 3 - Roles can execute: ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER, ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Yayın takvimini listeler. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.BroadcastCover gönderebilirsiniz. PersonalTrainer fotoğrafı için ise PhotoType.SmallUserAvatar gönderebilirsiniz.
     * @param {string} [date]
     * @param {boolean} [isLive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramApi
     */
    listBroadcastPrograms(date, isLive, options) {
        return (0, exports.BroadcastProgramApiFp)(this.configuration).listBroadcastPrograms(date, isLive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: RateBroadcast - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER
     * @summary Bir müşterinin, katılmış olduğu bir canlı yayın bittikten sonra, yayını puanlamasını sağlar.
     * @param {RateBroadcastCommand} [rateBroadcastCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramApi
     */
    rateBroadcast(rateBroadcastCommand, options) {
        return (0, exports.BroadcastProgramApiFp)(this.configuration).rateBroadcast(rateBroadcastCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: SetBurntCalories - Difficulty: 2 - Roles can execute: ROLE_PERSONAL_TRAINER
     * @summary Kişisel antrenörün, kendi yaptığı canlı yayın bittikten sonra canlı yayında yakılan kaloriyi girmesini sağlar.
     * @param {SetBurntCaloriesCommand} [setBurntCaloriesCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastProgramApi
     */
    setBurntCalories(setBurntCaloriesCommand, options) {
        return (0, exports.BroadcastProgramApiFp)(this.configuration).setBurntCalories(setBurntCaloriesCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BroadcastProgramApi = BroadcastProgramApi;
